module.exports = __webpack_public_path__ + "static/media/roboto-logo-white.d58d6598.svg";